import type { InternalSupportItem } from "../types/SupportItem.js";
import type { CapabilityFlags } from "../types/CapabilityFlags.js";

// Component-owned descriptor registry. Only wired capabilities are present;
// flags declared in CapabilityFlags but not yet wired to a descriptor are
// intentionally absent here. The fail-closed gate in App.ts treats an absent
// or undefined entry identically to a flag set to false.
export const CAPABILITY_REGISTRY: Partial<
  Record<keyof CapabilityFlags, InternalSupportItem>
> = {
  showLms: {
    id: "lms",
    label: "LMS",
    subtitle: "Learning Management System",
    iconKey: "clipboard",
    href: "https://learn.coxautoinc.com",
    target: "_blank",
    analyticsLabel: "lms",
  },
};
